import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HdrPlusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hdr_plus"}/>
}
